import { render } from "./ItemEditBasicInfo.vue?vue&type=template&id=d5367cd2&scoped=true&bindings={\"modelValue\":\"props\",\"item\":\"data\",\"sites\":\"data\",\"siteUrl\":\"data\",\"selectedFileText\":\"data\",\"siteUrlDomain\":\"options\",\"siteSuggestionsSourceUrl\":\"options\",\"getSites\":\"options\",\"sitePageSelect\":\"options\",\"setItemData\":\"options\",\"imageChange\":\"options\",\"removeImage\":\"options\"}"
import script from "./ItemEditBasicInfo.vue?vue&type=script&lang=js"
export * from "./ItemEditBasicInfo.vue?vue&type=script&lang=js"

import "./ItemEditBasicInfo.vue?vue&type=style&index=0&id=d5367cd2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d5367cd2"

export default script